import { render, staticRenderFns } from "./omt-select.vue?vue&type=template&id=21dc05ee&scoped=true&"
import script from "./omt-select.vue?vue&type=script&lang=js&"
export * from "./omt-select.vue?vue&type=script&lang=js&"
import style0 from "./omt-select.vue?vue&type=style&index=0&id=21dc05ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc05ee",
  null
  
)

export default component.exports